"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Week = exports.Event = void 0;
/**
 * An object that encapsulates the data for an NFL game.
 */
class Event {
    constructor(id, sportsbookEventId, sportsradarId, homeTeam, awayTeam, week, startDate, status, homeScore, awayScore) {
        this.id = id;
        this.sportsbookEventId = sportsbookEventId;
        this.sportsradarId = sportsradarId;
        this.homeTeam = homeTeam;
        this.awayTeam = awayTeam;
        this.week = week;
        this.status = status;
        this.startDate = startDate;
        this.homeScore = homeScore;
        this.awayScore = awayScore;
    }
}
exports.Event = Event;
// eslint-disable-next-line @typescript-eslint/no-namespace
(function (Event) {
    /**
     * An object that describes the status of a scheduled NFL game.
     */
    let Status;
    (function (Status) {
        /**
         * The game is scheduled.
         */
        Status["Scheduled"] = "Scheduled";
        /**
         * The game is currently being played.
         */
        Status["InProgress"] = "InProgress";
        /**
         * The game has completed.
         */
        Status["Final"] = "Final";
        /**
         * The game has completed in overtime.
         */
        Status["FinalOT"] = "F/OT";
        /**
         * Play was suspended.
         */
        Status["Suspended"] = "Suspended";
        /**
         * The game was postponed.
         */
        Status["Postponed"] = "Postponed";
        /**
         * The game was delayed.
         */
        Status["Delayed"] = "Delayed";
        /**
         * The game was canceled.
         */
        Status["Canceled"] = "Canceled";
        /**
         * The game was forfeit.
         */
        Status["Forfeit"] = "Forfeit";
        /**
         * The game has completed, but data is still being collected and reviewed by PFF analysts.
         */
        Status["DataReview"] = "DataReview";
    })(Status = Event.Status || (Event.Status = {}));
})(Event || (exports.Event = Event = {}));
/**
 * A list of all the weeks in the NFL season.
 */
var Week;
(function (Week) {
    Week["HallOfFameGame"] = "HF";
    Week["PreseasonWeek1"] = "P1";
    Week["PreseasonWeek2"] = "P2";
    Week["PreseasonWeek3"] = "P3";
    Week["PreseasonWeek4"] = "P4";
    Week["Week1"] = "1";
    Week["Week2"] = "2";
    Week["Week3"] = "3";
    Week["Week4"] = "4";
    Week["Week5"] = "5";
    Week["Week6"] = "6";
    Week["Week7"] = "7";
    Week["Week8"] = "8";
    Week["Week9"] = "9";
    Week["Week10"] = "10";
    Week["Week11"] = "11";
    Week["Week12"] = "12";
    Week["Week13"] = "13";
    Week["Week14"] = "14";
    Week["Week15"] = "15";
    Week["Week16"] = "16";
    Week["Week17"] = "17";
    Week["Week18"] = "18";
    Week["WildCardRound"] = "WC";
    Week["DivisionalRound"] = "DP";
    Week["ConferenceChampionship"] = "CC";
    Week["SuperBowl"] = "SB";
})(Week || (exports.Week = Week = {}));
//# sourceMappingURL=event.js.map